/**
 * Constantes utilizadas en el módulo de autenticación
 *
 * @remarks
 * - Centraliza URLs de navegación post-autenticación
 * - Keys de sessionStorage para tokens y datos de usuario
 * - Utilizado por ForceChangePasswordComponent y AuthService
 *
 * @example
 * ```typescript
 * import { AUTH_CONSTANTS } from './constants/auth.constants';
 *
 * sessionStorage.setItem(AUTH_CONSTANTS.STORAGE_KEY_TOKEN, token);
 * this.router.navigate([AUTH_CONSTANTS.PEOPLE_LIST_URL]);
 * ```
 */
export const AUTH_CONSTANTS = {
  // Session Storage Keys
  STORAGE_KEY_TOKEN: "token",
  STORAGE_KEY_FULLNAME: "fullName",

  // URLs de Navegación
  DEFAULT_RETURN_URL: "/",
  HOME_URL: "/inicio",
  UNAUTHORIZED_URL: "/unauthorized",
  SIN_PERFIL_URL: "/auth/sin-perfil",
  PEOPLE_LIST_URL: "/personas/list",
  TIME_REPORT_FORM_URL: "/time-report/form",
  FORCE_CHANGE_PASSWORD_URL: "/auth/change-password-required",

  // Password Visibility Types
  PASSWORD_TYPE_TEXT: "text",
  PASSWORD_TYPE_PASSWORD: "password",
} as const;
